import { render, staticRenderFns } from "./footer-collapsable.vue?vue&type=template&id=1725facd&scoped=true&"
import script from "./footer-collapsable.vue?vue&type=script&lang=js&"
export * from "./footer-collapsable.vue?vue&type=script&lang=js&"
import style0 from "./footer-collapsable.vue?vue&type=style&index=0&id=1725facd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1725facd",
  null
  
)

export default component.exports